export const COMPETITION_CONTAINER = {
  FILTERS: {
    scores: '',
    results: 'results',
    standings: 'standings',
    fixtures: 'fixtures',
    brackets: 'brackets',
    stats: 'stats',
    odds: 'odds',
    insights: 'insights',
    transfers: 'transfers',
    matches: 'matches',
    news: 'news',
    medals: 'medals',
    history: 'history',
    highlights: 'highlights'
  },

  INSIGHT_PAGE: {
    ITEMS: {
      oddsBy: true,
      topTrends: true,
      allTrends: true,
      outrights: true,
      bookmakersReview: true
    },

    KEYS: {
      oddsBy: 'oddsBy',
      topTrends: 'topTrends',
      allTrends: 'allTrends',
      outrights: 'outrights',
      bookmakersReview: 'bookmakersReview',
    }
  },

  ACTION_TYPES: {
    breadcrumbsHandler: 'breadcrumbsHandler',
    fetchMetadata: 'fetchMetadata'
  }
};
